export default __webpack_public_path__ + "static/home-hero-7b11cc00ced4d5d58de304d2902fcbdf.jpg";